import { Outlet } from 'react-router-dom';

import { PageDetailContent } from '@client/toolkit';

import { BuildingAssociationMatrix } from './building-association-matrix.component';
import { PageContentAnimation } from '../../../../../components/layout/page-content-animation';

export function BuildingAssociationsRoute() {
  return (
    <>
      <PageDetailContent align="left">
        <PageContentAnimation>
          <BuildingAssociationMatrix />
        </PageContentAnimation>
      </PageDetailContent>
      <Outlet />
    </>
  );
}
